var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('app-loader'):_c('asn-shipment-form',{attrs:{"packing":_vm.asn.packing || [],"saving":_vm.saving,"is-error-modal-shown":_vm.isErrorsModalShown,"error-modal-list":_vm.errorsModalList},on:{"save":_vm.save}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }